// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "NavList-module--wrapper--VFAwK";
export var horizontalList = "NavList-module--horizontalList--E1q5t";
export var title = "NavList-module--title--3YaaX";
export var verticalList = "NavList-module--verticalList--dwHz+";